const storageKey = (userId: string) => `kehrblatt:learning-login-reminder:${userId}`

/** The value is a public session row identifier, not a cookie or authentication credential. */
export async function claimLearningLoginReminder(
  userId: string,
  loginId: string,
): Promise<boolean> {
  const claim = () => {
    try {
      const key = storageKey(userId)

      if (window.localStorage.getItem(key) === loginId) return false

      window.localStorage.setItem(key, loginId)

      return true
    } catch {
      // Without durable browser storage, keep the passive reminder rather than repeat dialogs.
      return false
    }
  }

  if (typeof navigator !== "undefined" && navigator.locks) {
    try {
      return await navigator.locks.request(storageKey(userId), claim)
    } catch {
      return false
    }
  }

  return claim()
}
